import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useMephistoReview } from "../../shims/mephisto-review-hook";
import {
  Tabs,
  Tab,
} from "@blueprintjs/core";
import { useDropzone } from 'react-dropzone'

import Stats from "./Panels/Stats";
import Browse from "./Panels/Browse";

import { Navbar } from "../../components/Navbar";
import Footer from "../../components/Footer";
import { SearchBox } from "../../pages/Collection/SearchBox";
import { FilterBox } from "../../pages/Collection/FilterBox";
import { VersionSelector } from "../../components/VersionSelector/VersionSelector";

import useAtomWithUrlParam from "../../hooks/useAtomWithUrlParam";
import useStateWithUrlParam from "../../hooks/useStateWithUrlParam";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

import "./CollectionView.scss"
import { versionAtom, versionAtomDefault } from "../../atoms";

const tabid_to_verb = {
  'browse': 'Browsing',
  'stats': 'Stat Exploring',
}

function CollectionView() {
  useDocumentTitle('Ego4D Visualizer');
  const [page, setPage] = useStateWithUrlParam('p', 1);
  const [selectedTab, setSelectedTab] = useStateWithUrlParam('b', 'browse');
  const [query, setQueryAndURL, setQuery, setQueryURL] = useStateWithUrlParam('q', '');
  const [version, setVersionAndURL] = useAtomWithUrlParam(versionAtom, versionAtomDefault);
  const [filteredData, setFilteredData] = useState([]);
  const [searchFilter, setSearchFilter] = useState();
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files
    console.log(acceptedFiles);
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, noClick: true });

  const { filterData, isLoading, error, versionConfig, versionList } = useMephistoReview();

  useEffect(() => {
    if (version == '' && versionList) {
      setVersionAndURL(versionList[-1].name);
    }
  }, [versionList]);

  const locallyFilteredData = useMemo(
    () => {
      if (!!searchFilter) {
        const { order, metadata } = searchFilter;
        console.log(filteredData);
        const matchingItems =
          filteredData
            .filter(x => order.includes(x.video_uid.toLowerCase()))
            .map(obj => { return { ...obj, ...metadata[obj.video_uid.toLowerCase()] } })
            .sort((a, b) => order.indexOf(a.video_uid.toLowerCase()) - order.indexOf(b.video_uid.toLowerCase()))
        return matchingItems;
      }
      return filteredData;
    },
    [filteredData, searchFilter]);

  const total_duration_seconds = locallyFilteredData?.map((v) => (v['duration'] || 0)).reduce((s, a) => s + a, 0);

  const AugmentedNavbar = <>
    <Navbar invert={true} locallyFilteredData={locallyFilteredData} logoUrl={versionConfig?.logo}>
      <div style={{ display: 'flex', width: '75%' }}>
        <div style={{ flexBasis: '50%', marginRight: '5px', width: '0' }}>
          <FilterBox filterOptions={versionConfig?.filter_options ?? []} placeholder={versionConfig?.filter_placeholder} filterData={filterData} setFilteredData={setFilteredData} {...{ query, setQueryAndURL, setQuery, setQueryURL }} />
        </div>
        <div style={{ flexBasis: '50%', marginLeft: '5px', width: '0' }}>
          <SearchBox setSearchFilter={setSearchFilter} data={filterData} />
        </div>
      </ div>
    </ Navbar>

    <div className="navbar-row-stats">
      {tabid_to_verb[selectedTab]} <span className='nav-info-important'>{locallyFilteredData?.length} / {filterData?.length ?? 0} videos</span>.
      Total Duration: <span className='nav-info-important'>{
        total_duration_seconds > 3600 ? Math.round(total_duration_seconds / 3600 * 100) / 100 + ' hours' :
          total_duration_seconds > 60 ? Math.round(total_duration_seconds / 60 * 100) / 100 + ' minutes' :
            total_duration_seconds + ' seconds'
      }</span>.

      <div style={{ marginLeft: 'auto', marginBottom: '10px' }}>
        <VersionSelector />
      </div>
    </div>
  </>

  const DropzoneIndicator = <div id="dropzone-indicator">
    <div className="overlay" />
    <div className="overlay-border" />
    <div className="message">Drop data .jsonl here to visualize.</div>
  </div>

  return (
    <>
      {/* <div {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive && DropzoneIndicator} */}

      {AugmentedNavbar}

      <main id="all-item-view-wrapper">
        <Tabs selectedTabId={selectedTab} onChange={setSelectedTab} animate={true} className={'main-tabs'} renderActiveTabPanelOnly={true}>
          <Tab id={'browse'} title={'Browse'} panel={
            <Browse filteredData={locallyFilteredData} {...{ setSelectedTab, isLoading, page, setPage, error, versionConfig }} />
          } />

          <Tab id={'stats'} title={'Stats'} panel={
            <Stats filteredData={locallyFilteredData} filterOptions={versionConfig?.filter_options ?? []} {...{ query, setQueryAndURL }} />
          } />
        </Tabs>
      </main>

      <Footer logoUrl={versionConfig?.logo} />
      {/* </div> */}
    </>
  );
}

export default CollectionView;
